import { ComponentBaseType } from "@/src/shared/models/components";
import { ButtonProps } from "@mui/material";
import { WebShopIconProps } from "../../WebShopIcon/lib/type";
import {StepAnalytics} from "@/src/shared/models/analytics";

export interface HeaderActionProps {
    name: string | null;
    icon: {
        name: WebShopIconProps["name"];
        color: string | null;
    };
    variant: ButtonProps["variant"];
    method: "contacts" | "letter" | "viber";
    href?: string;
    analytics?: StepAnalytics;
}

export interface ContactProps {
    name: string | null;
    href: string;
    icon: {
        name: WebShopIconProps["name"];
        color: string | null;
    };
}

export interface HeaderActionsMenuProps {
    actions: HeaderActionProps[];
    contacts: ContactProps[];
}

export interface ViberActionProps extends HeaderActionProps {
    href?: string;
}

export type LetterAcionStageType = "contact-data" | "thank-you";
export type LetterActionProps = HeaderActionProps;

export interface ContactActionProps extends HeaderActionProps {
    contacts: ContactProps[];
}

export interface HeaderProps {
    name: string;
    label: string;
    displayName: string;
    type: "header";
    hidden: boolean;
    style?: {
        background: string;
        boxShadow: string;
        padding: string;
    };
    logo?: {
        src?: string | null;
        alt?: string | null;
        width?: number;
        height?: number;
    };
    workSchedules?: {
        title: string;
        subTitle: string;
    }[];
    notification?: {
        text?: string | null;
        hidden?: boolean;
    };
    actions?: HeaderActionProps[];
    contacts?: ContactProps[];
    displaySchedule?: TimeSettings;
    analytics?: StepAnalytics
}

export type HeaderComponentProps = ComponentBaseType<HeaderProps>;

export interface ContactsListProps {
    items: ContactProps[];
}

export interface HeaderAlertProps {
    title: string;
    onClose: () => void;
}

export interface HeaderAlertClientWrapperProps {
    title: string;
}

export enum DaysOfWeek {
    monday = "monday",
    tuesday = "tuesday",
    wednesday = "wednesday",
    thursday = "thursday",
    friday = "friday",
    saturday = "saturday",
    sunday = "sunday",
}

export type TimeSettings = {
    dateStart?: string;
    dateEnd?: string;
    timeStart?: string;
    timeEnd?: string;
    daysSettings?: Record<
        DaysOfWeek,
        { enabled?: boolean; start?: string; end?: string }
    >;
};
